import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Loader2, ArrowLeft } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-teal-500/20">
            <ShieldCheck className="h-5 w-5 text-teal-500" />
          </div>
          <span className="font-display text-lg font-extrabold text-slate-900">Scolaris <span className="text-teal-600">Central</span></span>
        </div>
        <h2 className="font-display text-2xl font-bold text-slate-900">Mot de passe oublie</h2>
        {sent ? (
          <div className="mt-6 rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800" data-testid="forgot-confirmation">
            Si cet email est enregistre, un lien de reinitialisation vient d'etre envoye. Verifiez votre boite de reception.
          </div>
        ) : (
          <>
            <p className="text-sm text-slate-500 mt-1">Saisissez votre email pour recevoir un lien de reinitialisation.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="email">Adresse email</Label>
                <Input id="email" data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" />
              </div>
              {error && <p className="text-sm text-rose-600">{error}</p>}
              <Button type="submit" data-testid="forgot-submit" disabled={loading} className="w-full bg-teal-600 hover:bg-teal-700">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Envoyer le lien"}
              </Button>
            </form>
          </>
        )}
        <Link to="/login" className="mt-6 inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-teal-600">
          <ArrowLeft className="h-4 w-4" /> Retour a la connexion
        </Link>
      </div>
    </div>
  );
}
